var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:_vm.baseClass},[_c('KpisLegend',{class:`${_vm.baseClass}__legend`,attrs:{"items":_vm.kpisItems},model:{value:(_vm.selectedKpis),callback:function ($$v) {_vm.selectedKpis=$$v},expression:"selectedKpis"}}),_c('div',{ref:"component",class:`${_vm.baseClass}__distribution-chart`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }